import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/stadium-shops/src/components/404/index.js");
